import dayjs, { Dayjs } from "dayjs";

class Utils {
  constructor() {}

  // Convert to boolean-based format
  convertToBooleanFormatRole(data: any) {
    const allPermissions = this.permissions.map((p) => p.id);

    return {
      ...data,
      permissions: Object.fromEntries(
        allPermissions.map((key) => [
          key,
          {
            view: Array.isArray(data.permissions?.[key])
              ? data.permissions[key].includes("view")
              : data.permissions?.[key] instanceof Set
              ? data.permissions[key].has("view")
              : false,
            edit: Array.isArray(data.permissions?.[key])
              ? data.permissions[key].includes("edit")
              : data.permissions?.[key] instanceof Set
              ? data.permissions[key].has("edit")
              : false,
            // none: Array.isArray(data.permissions?.[key])
            //   ? data.permissions[key].includes("none")
            //   : data.permissions?.[key] instanceof Set
            //   ? data.permissions[key].has("none")
            //   : false,
          },
        ])
      ),
      individualPermissions: Object.fromEntries(
        allPermissions.map((key) => [
          key,
          {
            view: Array.isArray(data.individualPermissions?.[key])
              ? data.individualPermissions[key].includes("view")
              : data.individualPermissions?.[key] instanceof Set
              ? data.individualPermissions[key].has("view")
              : false,
            edit: Array.isArray(data.individualPermissions?.[key])
              ? data.individualPermissions[key].includes("edit")
              : data.individualPermissions?.[key] instanceof Set
              ? data.individualPermissions[key].has("edit")
              : false,
            // none: Array.isArray(data.individualPermissions?.[key])
            //   ? data.individualPermissions[key].includes("none")
            //   : data.individualPermissions?.[key] instanceof Set
            //   ? data.individualPermissions[key].has("none")
            //   : false,
          },
        ])
      ),
    };
  }

  convertToBooleanFormatRoleOfPermissions(data: any) {
    const allPermissions = this.permissions.map((p) => p.id);

    return {
      ...data,
      permissions: Object.fromEntries(
        allPermissions.map((key) => [
          key,
          {
            view: Array.isArray(data.permissions[key])
              ? data.permissions[key].includes("view")
              : data.permissions[key] instanceof Set
              ? data.permissions[key].has("view")
              : false,
            edit: Array.isArray(data.permissions[key])
              ? data.permissions[key].includes("edit")
              : data.permissions[key] instanceof Set
              ? data.permissions[key].has("edit")
              : false,
            //  none: Array.isArray(data.permissions[key])
            //     ? data.permissions[key].includes("none")
            //     : data.permissions[key] instanceof Set
            //     ? data.permissions[key].has("none")
            //     : false,
          },
        ])
      ),
    };
  }

  convertToBooleanFormatRoleOfIndividualPermissions(data: any) {
    const allPermissions = this.permissions.map((p) => p.id);

    return {
      ...data,
      individualPermissions: Object.fromEntries(
        allPermissions.map((key) => [
          key,
          {
            view: Array.isArray(data.individualPermissions[key])
              ? data.individualPermissions[key].includes("view")
              : data.individualPermissions[key] instanceof Set
              ? data.individualPermissions[key].has("view")
              : false,
            edit: Array.isArray(data.individualPermissions[key])
              ? data.individualPermissions[key].includes("edit")
              : data.individualPermissions[key] instanceof Set
              ? data.individualPermissions[key].has("edit")
              : false,
            // none: Array.isArray(data.permissions[key])
            //   ? data.permissions[key].includes("none")
            //   : data.permissions[key] instanceof Set
            //   ? data.permissions[key].has("none")
            //   : false,
          },
        ])
      ),
    };
  }

  // Reverse: Convert back to array-based format
  reverseToArrayFormatRole(data: any) {
    return {
      ...data,
      permissions: Object.fromEntries(
        Object.entries(data.permissions ?? {}).map(([key, actions]: any) => [
          key,
          Object.entries(actions ?? {})
            .filter(([action, isAllowed]) => isAllowed)
            .map(([action]) => action),
        ])
      ),
      individualPermissions: Object.fromEntries(
        Object.entries(data.individualPermissions ?? {}).map(
          ([key, actions]: any) => [
            key,
            Object.entries(actions ?? {})
              .filter(([action, isAllowed]) => isAllowed)
              .map(([action]) => action),
          ]
        )
      ),
    };
  }

  avatarList(noOfUser: number) {
    const allAvatars = [
      { id: "1", avatar: process.env.PUBLIC_URL + "/imgs/avatar/1.jpg" },
      { id: "2", avatar: process.env.PUBLIC_URL + "/imgs/avatar/2.jpg" },
      { id: "3", avatar: process.env.PUBLIC_URL + "/imgs/avatar/3.png" },
      { id: "4", avatar: process.env.PUBLIC_URL + "/imgs/avatar/4.png" },
      { id: "5", avatar: process.env.PUBLIC_URL + "/imgs/avatar/5.png" },
      { id: "6", avatar: process.env.PUBLIC_URL + "/imgs/avatar/6.png" },
      { id: "7", avatar: process.env.PUBLIC_URL + "/imgs/avatar/7.png" },
      { id: "8", avatar: process.env.PUBLIC_URL + "/imgs/avatar/8.jpg" },
      { id: "9", avatar: process.env.PUBLIC_URL + "/imgs/avatar/9.png" },
      { id: "10", avatar: process.env.PUBLIC_URL + "/imgs/avatar/10.png" },
      { id: "11", avatar: process.env.PUBLIC_URL + "/imgs/avatar/11.jpg" },
      { id: "12", avatar: process.env.PUBLIC_URL + "/imgs/avatar/12.jpg" },
    ];

    // Determine the number of avatars to return based on the conditions
    let count: number;
    if (noOfUser > 4) {
      count = 3;
    } else if (noOfUser === 4) {
      count = 4;
    } else {
      count = noOfUser;
    }

    // Fisher-Yates Shuffle
    const shuffle = (array: any[]) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = i % (array.length - 1); // Replace Math.random() with a deterministic approach
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    // Shuffle the array and pick the required number of avatars
    const shuffled = shuffle(allAvatars);
    return shuffled.slice(0, count);
  }

  camelCaseToWords(input: string): string {
    return input
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Insert space between lowercase and uppercase
      .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2") // Handle uppercase sequences like 'PDFReader'
      .replace(/_/g, " ") // Optional: Handle underscores if needed
      .replace(/-/g, " ") // Optional: Handle dashes if needed
      .replace(/ +/g, " ") // Remove extra spaces
      .trim() // Remove leading/trailing spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  }

  onlyNumber(e: any): any {
    return (e.target.value = e.target.value.replace(/\D/g, ""));
  }

  onlyPriceNumber(e: any): any {
    const value = e.target.value;
    // Regular expression for decimals with up to 2 digits after the decimal point
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(value)) {
      return (e.target.value = value.slice(0, -1)); // Remove the last invalid character
    }
  }

  onlyText(e: any): any {
    const input = e.target.value;
    // Allow only alphanumeric and space, then collapse multiple spaces
    return (e.target.value = input
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove non-alphanumeric characters except space
      .replace(/\s+/g, " ") // Replace multiple spaces with one
      .trimStart()); // Optional: prevent leading spaces
  }

  onlyTextWithEmail(e: any): any {
    const input = e.target.value;
    // Allow only alphanumeric, @ symbol and space, then collapse multiple spaces
    return (e.target.value = input
      .replace(/[^a-zA-Z0-9@_ ]/g, "") // Remove non-alphanumeric characters except @ and space
      .replace(/\s+/g, " ") // Replace multiple spaces with one
      .trimStart()); // Optional: prevent leading spaces
  }

  capitalizeFirstLetter(string: string) {
    if (!string) return ""; // Handle empty or null strings
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Refund status, presented consistently.
   *
   * The Refunds list had its own label + colour mapping while Order Details
   * hardcoded a green "Refunded" chip on every row -- so the same refund read as
   * "Refund Processing" on one screen and "Refunded" on another, and a declined
   * or failed refund looked like money already sent. Shared here so the two
   * cannot drift again.
   */
  refundStatusLabel(status?: string): string {
    if (!status) return "Unknown";
    return status
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  refundStatusColour(
    status?: string
  ): "success" | "warning" | "info" | "error" | "default" {
    switch (status) {
      case "paid":
      case "refunded":
        return "success";
      case "credit_memo":
      case "refund_requested":
        return "warning";
      case "refund_processing":
        return "info";
      case "refund_declined":
      case "refund_failed":
        return "error";
      default:
        return "default";
    }
  }

  /** Available permissions configuration */
  get permissions() {
    return [
      // Dashboard is view-only: it has no write actions, so the roles UI hides
      // its Edit checkbox (see viewOnly handling in AddRoles/PermissionsByUsers).
      { id: "dashboard", label: "Dashboard", viewOnly: true },
      { id: "categories", label: "Categories" },
      { id: "products", label: "Product Management" },
      { id: "inventories", label: "Inventory Management" },
      { id: "supplier", label: "Supplier" },
      { id: "customers", label: "Customers" },
      { id: "orders", label: "Order Management" },
      { id: "profile", label: "Profiles" },
      { id: "employee", label: "User Management" },
      { id: "roles", label: "Role Management" },
      { id: "reports", label: "Reports Management" },
      { id: "customer-help-service", label: "Customer Help Service" },
      { id: "home-screen", label: "Home Screen" },
      { id: "cms", label: "CMS" },
      { id: "settings", label: "Settings" },
    ];
  }

  // Reusable debounce function
  debounce(func: Function, delay: number) {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    return (...args: any[]) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  handleDownload(path: string) {
    if (!path) return;

    const link: any = document.createElement("a");
    link.href = path; // Path in the public directory
    link.download = path.split("/").pop() || "product_data.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  priceType(denominations: any[]) {
    let hasFixed = false;
    let hasRange = false;

    for (const item of denominations) {
      if (item.type === "fixed") {
        hasFixed = true;
      }
      if (item.type === "range") {
        hasRange = true;
      }
    }

    if (hasFixed && hasRange) {
      return "Both";
    } else if (hasFixed) {
      return "Fixed";
    } else if (hasRange) {
      return "Range";
    } else {
      return "None"; // In case neither is found
    }
  }

  getRelativeDate(date: Date): string {
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays < 1) return "Today";
    if (diffInDays < 2) return "Yesterday";
    if (diffInDays < 7) return `${diffInDays} days ago`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} weeks ago`;
    if (diffInDays < 365) return `${Math.floor(diffInDays / 30)} months ago`;
    return `${Math.floor(diffInDays / 365)} years ago`;
  }

  commonSearchStyle(): any {
    return {
      width: "100%",
      minWidth: "200px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      "& .MuiInputLabel-root": {
        transform: "translate(12px, 11px)", // Adjust label position
        fontSize: "13px", // Adjust label font size
      },
      "& .MuiInputLabel-shrink": {
        transform: "translate(12px, -7px) scale(0.78)", // Adjust label position when focused
        fontSize: "12px",
        backgroundColor: "transparent",
      },
    };
  }

  commonInputPropsSearchStyle(): any {
    return {
      sx: {
        maxHeight: 40,
        height: 40, // control overall height
        padding: 0, // remove unwanted padding
        backgroundColor: "#fff",
        borderRadius: "8px",
      },
    };
  }

  isDateChanged = (range?: [Dayjs | null, Dayjs | null]) => {
    const today = dayjs();
    const [start, end] = range || [];

    return !!(
      start &&
      end &&
      (!start.isSame(today, "day") || !end.isSame(today, "day"))
    );
  };

  formatCapitalizeWord = (status: any) => {
    return status
      .split("_") // Split by underscore
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "); // Join the words with space
  };

  formatEuro(amount: number | string) {
    const num = Number(amount) || 0;
    return `${num.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} €`;
  }
}

export default new Utils();
